import assetClassesMock from '@/mocks/AssetClasses'

export default {
  all: assetClassesMock.items,
  findById (id) {
    return this.all.find(x => x.id === id)
  }
}
